export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5249.bd59de18.jpg";